import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
var cls = 'tab-pane';
var TabPane = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useConfig = useConfig(),
    createNamespace = _useConfig.createNamespace,
    prefixCls = _useConfig.prefixCls;
  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), props.className);
  return _jsx("div", Object.assign({
    ref: ref,
    role: "tabpanel",
    className: classes
  }, {
    children: props.children
  }));
});
TabPane.displayName = 'TabPane';
export default TabPane;